/**
 * Dashboard form IDs for Pile Driving USA.
 * Create matching forms in the leads dashboard, then paste IDs here.
 * Legacy Google Sheet mapping:
 * - contact: sheet 63
 * - popup: sheet 64
 * - footer / exitIntent: sheet 65
 * - landingPage: sheet 78
 */
export const FORM_IDS = {
  contact: "6ac5342c",
  popup: "6ac534ee",
  footer: "6ac53512",
  exitIntent: "6ac53524",
  landingPage: "6ac53451",
};

export const FORM_NAMES = {
  contact: "contact-form",
  popup: "popup-form",
  footer: "footer-form",
  exitIntent: "exit-intent-form",
  landingPage: "landing-page-form",
};
